import { useState, useEffect } from "react";
import { Menu, X } from "lucide-react";
import { LANDING } from "@/constants/testIds";
import { scrollToId, scrollToTop, DEMO_MAILTO } from "@/lib/scroll";

const links = [
    { id: "features", label: "Features", testid: LANDING.navLinkFeatures },
    { id: "pricing", label: "Pricing", testid: LANDING.navLinkPricing },
    { id: "faq", label: "FAQ", testid: LANDING.navLinkFaq },
    { id: "founders", label: "About Us", testid: LANDING.navLinkAbout },
    { id: "contact", label: "Contact", testid: LANDING.navLinkContact },
];

export const Navbar = () => {
    const [open, setOpen] = useState(false);
    const [scrolled, setScrolled] = useState(false);

    useEffect(() => {
        const onScroll = () => setScrolled(window.scrollY > 20);
        onScroll();
        window.addEventListener("scroll", onScroll);
        return () => window.removeEventListener("scroll", onScroll);
    }, []);

    const go = (id) => {
        setOpen(false);
        scrollToId(id);
    };

    return (
        <header
            className={`fixed top-0 inset-x-0 z-50 transition-all duration-300 ${
                scrolled
                    ? "bg-white/85 backdrop-blur-xl border-b border-[#091524]/10"
                    : "bg-transparent"
            }`}
        >
            <nav className="max-w-7xl mx-auto px-6 md:px-12 lg:px-16 h-16 md:h-20 flex items-center justify-between">
                <button
                    data-testid={LANDING.navLogo}
                    onClick={scrollToTop}
                    className="flex items-center group"
                    aria-label="Apex Pro home"
                >
                    <img
                        src="https://customer-assets.emergentagent.com/job_data-safety-vault/artifacts/wmvlaiol_Apex%20Pro%20Logo%20-%20White.JPG"
                        alt="Apex Pro"
                        className="h-10 md:h-12 w-auto object-contain"
                    />
                </button>

                <div className="hidden md:flex items-center gap-10">
                    {links.map((l) => (
                        <button
                            key={l.id}
                            data-testid={l.testid}
                            onClick={() => go(l.id)}
                            className="text-sm font-semibold text-[#091524]/80 hover:text-[#0052CC] transition-colors duration-200 relative group"
                        >
                            {l.label}
                            <span className="absolute -bottom-1 left-0 w-0 h-0.5 bg-[#0052CC] group-hover:w-full transition-all duration-300" />
                        </button>
                    ))}
                </div>

                <div className="hidden md:block">
                    <a
                        data-testid={LANDING.navRequestDemoBtn}
                        href={DEMO_MAILTO}
                        className="inline-block bg-[#091524] hover:bg-[#0052CC] text-white text-sm font-semibold px-5 py-2.5 rounded-sm transition-all duration-300"
                    >
                        Request a Demo
                    </a>
                </div>

                <button
                    data-testid={LANDING.navMobileToggle}
                    className="md:hidden p-2 text-[#091524]"
                    onClick={() => setOpen(!open)}
                    aria-label="Toggle menu"
                >
                    {open ? <X size={22} /> : <Menu size={22} />}
                </button>
            </nav>

            {open && (
                <div className="md:hidden bg-white border-t border-[#091524]/10">
                    <div className="px-6 py-6 flex flex-col gap-5">
                        {links.map((l) => (
                            <button
                                key={l.id}
                                data-testid={`${l.testid}-mobile`}
                                onClick={() => go(l.id)}
                                className="text-left text-base font-semibold text-[#091524]"
                            >
                                {l.label}
                            </button>
                        ))}
                        <button
                            data-testid={`${LANDING.navRequestDemoBtn}-mobile`}
                            onClick={() => go("contact")}
                            className="bg-[#091524] text-white font-semibold py-3 rounded-sm mt-2"
                        >
                            Request a Demo
                        </button>
                    </div>
                </div>
            )}
        </header>
    );
};
